import { useTranslation } from 'react-i18next';
import { useMutation } from '@tanstack/react-query';

import { ServiceError, useError } from 'Src/network/useError';

import service from './forgotPasswordService';

const useMutation_TriggerPWReset = (onError?: (error: ServiceError) => void) => {
  const { t } = useTranslation();
  const { parseError } = useError({ activity: t('forgotPassword.errors.reset') });
  return useMutation({
    mutationFn: async (...args: Parameters<typeof service.triggerPWReset>) => {
      try {
        return await service.triggerPWReset(...args);
      } catch (e) {
        throw parseError(e);
      }
    },
    onError,
  });
};

const useForgotPassword = {
  mutate: {
    reset: useMutation_TriggerPWReset,
  }
};

export { useForgotPassword };
